import { extend, setInteractionMode } from 'vee-validate';
import {
	required,
	email,
	min,
	max,
	confirmed,
} from 'vee-validate/dist/rules';
import isURL from 'validator/es/lib/isURL';

// Install rules
extend('required', { ...required, message: '{_field_} cannot be empty' });
extend('email', email);
extend('min', { ...min, message: '{_field_} must have at least {length} characters' });
extend('max', max);
extend('confirmed', confirmed);
extend('url', {
	validate(value) {
		if (isURL(value)) {
			return true;
		}

		return '{_field_} must be a valid URL';
	},
});

setInteractionMode('aggressive-touch', () => ({
	on: ['input', 'change', 'blur'],
}));
